import styled from "styled-components";

export const SideInfoContainer = styled.div`
  padding: 0 10px;
`;
